var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb-notification"},[_c('div',{staticClass:"sb-notification-wrapper date-wrapper"},[_vm._t("date")],2),_vm._v(" "),_c('div',{staticClass:"sb-notification-wrapper content-wrapper"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"sb-notification-wrapper actions-wrapper"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }